import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import './Marketing.css';

export default function LandingPage() {
  return (
    <div className="marketing-page">
      <Seo
        title="3AM AI Life Journal — Overcome Anxiety, Reach Your Goals"
        description="Life Journal by 3AM AI helps you overcome anxiety, reach your goals, track moods, and get calm AI coaching — private, simple, and built for clarity."
        path="/"
      />
      <SiteNav />
      <main>
        <section className="hero" aria-label="3AM AI Life Journal">
          <div className="hero__plane" aria-hidden="true">
            <div className="hero__orb hero__orb--a" />
            <div className="hero__orb hero__orb--b" />
            <div className="hero__grain" />
          </div>
          <div className="hero__content">
            <p className="hero__brand m-animate-in">3AM AI</p>
            <h1 className="hero__headline m-animate-in m-animate-in--delay-1">
              Overcome anxiety.
              <br />
              Reach every goal.
            </h1>
            <p className="hero__sub m-animate-in m-animate-in--delay-2">
              Life Journal — track your moods and think clearly with a calm AI coach, built for the quiet hours when change begins.
            </p>
            <div className="m-btn-row m-animate-in m-animate-in--delay-3">
              <Link to="/signup" className="m-btn m-btn--primary">
                Start free
              </Link>
              <Link to="/product#journey" className="m-btn m-btn--ghost">
                How it works
              </Link>
            </div>
          </div>
        </section>

        <section className="what-we-do" aria-labelledby="what-heading">
          <div className="m-section">
            <p className="m-section__label">What we do</p>
            <h2 id="what-heading" className="m-section__title">
              Clarity in three steps
            </h2>
            <p className="m-section__lede">
              Simple tools for the moments you want to move forward — not noise, not clutter.
            </p>
            <div className="what-we-do__grid">
              <article className="what-step">
                <div className="what-step__num">01</div>
                <h3>Write it down</h3>
                <p>Capture what&apos;s on your mind in a private journal that stays yours.</p>
              </article>
              <article className="what-step">
                <div className="what-step__num">02</div>
                <h3>See the pattern</h3>
                <p>Moods, goals, and recurring themes come into focus over time.</p>
              </article>
              <article className="what-step">
                <div className="what-step__num">03</div>
                <h3>Move with intention</h3>
                <p>A calm AI coach asks better questions so you find your next step.</p>
              </article>
            </div>
            <div className="m-btn-row">
              <Link to="/product#journey" className="m-btn m-btn--ghost">
                See the full product journey
              </Link>
            </div>
          </div>
        </section>

        <section aria-labelledby="features-heading">
          <div className="m-section">
            <p className="m-section__label">Life Journal</p>
            <h2 id="features-heading" className="m-section__title">
              Built for real progress
            </h2>
            <p className="m-section__lede">
              Everything you need to steady anxiety, hit goals, and understand your days.
            </p>
            <div className="features__list">
              <article className="feature-block">
                <h3>Overcome anxiety</h3>
                <p>
                  Name what&apos;s weighing on you. Spot loops early. Build steadiness without overwhelm.
                </p>
              </article>
              <article className="feature-block">
                <h3>Reach your goals</h3>
                <p>
                  Turn vague intentions into clear targets you can actually track and revisit.
                </p>
              </article>
              <article className="feature-block">
                <h3>Mood tracker</h3>
                <p>
                  Log how you feel day by day and watch patterns emerge — quietly, without judgment.
                </p>
              </article>
              <article className="feature-block">
                <h3>AI coach</h3>
                <p>
                  A thoughtful companion that listens first, then helps you think — never lectures.
                </p>
              </article>
            </div>
          </div>
        </section>

        <aside className="trust-strip" aria-label="Trust">
          <p>Private by design. Light by intention. Made for people who want clarity — not noise.</p>
        </aside>

        <section className="cta-band" aria-labelledby="cta-heading">
          <h2 id="cta-heading">Begin with 3AM AI</h2>
          <p>Start free. Upgrade when you&apos;re ready for more depth.</p>
          <div className="m-btn-row">
            <Link to="/signup" className="m-btn m-btn--primary">
              Create your journal
            </Link>
            <Link to="/about" className="m-btn m-btn--ghost">
              Our mission
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
